import { useMemo } from "react";
import { getTicketPermissions } from "./PermissionMatrix";

function normalizeRole({ producerView, adminView, permissions }) {
    if (permissions) {
        if(permissions.hasAdminPrivileges) return "admin";
        if(permissions.hasProducerPrivileges) return "producer";
        return "user";
    }
    if (adminView) return "admin";
    if (producerView) return "producer";
    return "user";
}

function useTicketPermissions({
    producerView,
    adminView,
    permissions,
	status,
}) {
    const ticketPermissions = useMemo(() => {
        const role = normalizeRole({ permissions, adminView, producerView });
        const perms = getTicketPermissions(role, status);
        return perms;
    }, [adminView, producerView, permissions, status]);

    return ticketPermissions;
}

export default useTicketPermissions;
